import { TIME_ZONE } from '@/utils';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * @description 根据传入UTC格式化时间戳
 */
export function formatTimeZone(timestamp: number, utc: IUtc = 'UTC+08:00', format = 'YYYY年MM月DD日 HH:mm:ss') {
  return dayjs.tz(timestamp, TIME_ZONE[utc]?.UTC ?? 'Etc/GMT-8').format(format);
}
